import CameraIcon from "@mui/icons-material/CameraAlt";
import FolderIcon from "@mui/icons-material/Folder";
import LinkIcon from "@mui/icons-material/Link";
import NoteIcon from "@mui/icons-material/MusicNote";
import PlayIcon from "@mui/icons-material/PlayCircleFilled";
import SheetIcon from "@mui/icons-material/Description";
import VideocamIcon from "@mui/icons-material/Videocam";
import UnknownIcon from "@mui/icons-material/HelpOutline";
import { Create } from "@mui/icons-material";

const AUDIO_ICON = NoteIcon;
const FILE_ICON = FolderIcon;
const GAME_ICON = PlayIcon;
const IMAGE_ICON = CameraIcon;
const LINK_ICON = LinkIcon;
const VIDEO_ICON = VideocamIcon;
const WORKSHEET_ICON = SheetIcon;

export const NON_ASSIGNED_PAGE = -1;
export const MATERIAL_TYPES = ["audio", "file", "game", "image", "link", "video", "worksheet", "directplayer"];

export const ICONS = {
  audio: AUDIO_ICON,
  file: FILE_ICON,
  game: GAME_ICON,
  image: IMAGE_ICON,
  link: LINK_ICON,
  video: VIDEO_ICON,
  worksheet: WORKSHEET_ICON,
  directplayer: AUDIO_ICON
};

export function getIconByListIconType(type) {
  switch (type) {
    case "audio":
      return NoteIcon;
    case "video":
      return VideocamIcon;
    case "image":
      return CameraIcon;
    case "docviewer":
      return SheetIcon;
    case "link":
      return LinkIcon;
    case "arbeitsblatteditor":
      return Create;
    case "unknown":
    default:
      return UnknownIcon;
  }
}
